import { observer } from 'mobx-react-lite';
import { ISaleCompFilterSettings } from '../../interfaces/IFilterSettings';
import { SaleCompPropertyType } from '../../interfaces/ISaleComp';
import { saleCompPropertyTypeToString } from '../../utils/enumUtils';
import { formatDateForInput, parseDate } from '../../utils/utils';
import styles from './GlobalFilters.module.css';

function GlobalFiltersSaleCompsTab({ saleCompFiltersState, setSaleCompFiltersState }: IGlobalFiltersSaleCompsTabProps) {
    return (
        <div className={styles.columns}>
            <div className={styles.column}>
                <label className={styles.label}>
                    USABLE LAND SIZE
                    <div>
                        <input type="number" className={styles.numberInput} placeholder="Enter min" value={saleCompFiltersState.minUsableLandSize || ""} onChange={e => setSaleCompFiltersState({
                            ...saleCompFiltersState,
                            minUsableLandSize: e.target.valueAsNumber || null,
                        })} />
                        &nbsp;-&nbsp;
                        <input type="number" className={styles.numberInput} placeholder="Enter max" value={saleCompFiltersState.maxUsableLandSize || ""} onChange={e => setSaleCompFiltersState({
                            ...saleCompFiltersState,
                            maxUsableLandSize: e.target.valueAsNumber || null,
                        })} />
                    </div>
                </label>
                <label className={styles.label}>
                    PARCEL SIZE
                    <div>
                        <input type="number" className={styles.numberInput} placeholder="Enter min" value={saleCompFiltersState.minParcelSize || ""} onChange={e => setSaleCompFiltersState({
                            ...saleCompFiltersState,
                            minParcelSize: e.target.valueAsNumber || null,
                        })} />
                        &nbsp;-&nbsp;
                        <input type="number" className={styles.numberInput} placeholder="Enter max" value={saleCompFiltersState.maxParcelSize || ""} onChange={e => setSaleCompFiltersState({
                            ...saleCompFiltersState,
                            maxParcelSize: e.target.valueAsNumber || null,
                        })} />
                    </div>
                </label>
                <label className={styles.label}>
                    BUILDING SIZE
                    <div>
                        <input type="number" className={styles.numberInput} placeholder="Enter min" value={saleCompFiltersState.minBuildingSize || ""} onChange={e => setSaleCompFiltersState({
                            ...saleCompFiltersState,
                            minBuildingSize: e.target.valueAsNumber || null,
                        })} />
                        &nbsp;-&nbsp;
                        <input type="number" className={styles.numberInput} placeholder="Enter max" value={saleCompFiltersState.maxBuildingSize || ""} onChange={e => setSaleCompFiltersState({
                            ...saleCompFiltersState,
                            maxBuildingSize: e.target.valueAsNumber || null,
                        })} />
                    </div>
                </label>
            </div>
            <div className={styles.column}>
                <label className={styles.label}>
                    SALE PRICE
                    <div>
                        <input type="number" className={styles.numberInput} placeholder="Enter min" value={saleCompFiltersState.minSalePrice || ""} onChange={e => setSaleCompFiltersState({
                            ...saleCompFiltersState,
                            minSalePrice: e.target.valueAsNumber || null,
                        })} />
                        &nbsp;-&nbsp;
                        <input type="number" className={styles.numberInput} placeholder="Enter max" value={saleCompFiltersState.maxSalePrice || ""} onChange={e => setSaleCompFiltersState({
                            ...saleCompFiltersState,
                            maxSalePrice: e.target.valueAsNumber || null,
                        })} />
                    </div>
                </label>
                <label className={styles.label}>
                    SALE DATE
                    <div>
                        <input type="date" className={styles.numberInput} value={formatDateForInput(saleCompFiltersState.minSaleDate || undefined)} onChange={e => setSaleCompFiltersState({
                            ...saleCompFiltersState,
                            minSaleDate: parseDate(e.target.value) || null,
                        })} />
                        &nbsp;-&nbsp;
                        <input type="date" className={styles.numberInput} value={formatDateForInput(saleCompFiltersState.maxSaleDate || undefined) || ""} onChange={e => setSaleCompFiltersState({
                            ...saleCompFiltersState,
                            maxSaleDate: parseDate(e.target.value) || null,
                        })} />
                    </div>
                </label>
                <label className={styles.label}>
                    DATE MODIFIED
                    <div>
                        <input type="date" className={styles.numberInput} value={formatDateForInput(saleCompFiltersState.minDateModified || undefined)} onChange={e => setSaleCompFiltersState({
                            ...saleCompFiltersState,
                            minDateModified: parseDate(e.target.value) || null,
                        })} />
                        &nbsp;-&nbsp;
                        <input type="date" className={styles.numberInput} value={formatDateForInput(saleCompFiltersState.maxDateModified || undefined) || ""} onChange={e => setSaleCompFiltersState({
                            ...saleCompFiltersState,
                            maxDateModified: parseDate(e.target.value) || null,
                        })} />
                    </div>
                </label>
                <label className={styles.label}>
                    PROPERTY TYPE
                    <div className={styles.tags}>
                        {Object.values(SaleCompPropertyType).map(propertyType => (
                            <div
                                key={propertyType}
                                className={saleCompFiltersState.propertyTypes.includes(propertyType) ? styles.selectedTag : styles.tag}
                                onClick={() => setSaleCompFiltersState({
                                    ...saleCompFiltersState,
                                    propertyTypes: !saleCompFiltersState.propertyTypes.includes(propertyType) ? [
                                        ...saleCompFiltersState.propertyTypes,
                                        propertyType,
                                    ] : saleCompFiltersState.propertyTypes.filter(s => s !== propertyType),
                                })}
                            >
                                {saleCompPropertyTypeToString(propertyType)}
                            </div>
                        ))}
                    </div>
                </label>
            </div>
        </div>
    );
};

export default observer(GlobalFiltersSaleCompsTab);

interface IGlobalFiltersSaleCompsTabProps {
    saleCompFiltersState: ISaleCompFilterSettings;
    setSaleCompFiltersState: (value: ISaleCompFilterSettings) => void;
}